<template>
  <div>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Módosítás'"
      placement="top"
      v-can="'settings.customstariffnumber.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateCustomsTariffNumber"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'settings.customstariffnumber.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteCustomsTariffNumber"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>
<script>
  export default {
    props: ['customsTariffNumber'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false
      };
    },
    methods: {
      async deleteCustomsTariffNumber() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('customsTariffNumber/delete', this.customsTariffNumber.id);
          this.$store.dispatch('customsTariffNumber/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateCustomsTariffNumber() {
        this.$router.push('/lists/customs-tariff-numbers/update/' + this.customsTariffNumber.id);
      }
    }
  };
</script>
